export default {
  name : 'PointsCard',
  props: {
    wordings: {
      type: Object,
      default: () => {},
    },
    rewardPoints: {
      type: [Number, String],
      required: false,
      default: 0,
    },
    statusPoints: {
      type: [Number, String],
      required: false,
      default: 0,
    },
    nights: {
      type: [Number, String],
      required: false,
      default: 0,
    },
    lang: {
      type: String,
    },
  },
  methods: {
    formatNumberDisplayByLang: function(value) {
      return new Intl.NumberFormat(this.lang).format(value);
    }
  }
}
